import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { WebActivityLinkedService } from './web-activity.linkedservice';

@Metamodel.model({
    name: 'FabricDataPipelines',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.FabricDataPipelines),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.FabricDataPipelines)
    ]
})

export class FabricDataPipelinesLinkedService extends WebActivityLinkedService {}